import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles';

const OutOfStockIcon = props => {
  const { title, width, height, toneDown } = props;
  return (
    <svg
      className={styles['out-of-stock'].withModifier({ 'tone-down': toneDown })}
      height={height}
      width={width}
      viewBox="0 0 29 11"
    >
      {title && <title>{title}</title>}
      <path
        d="M23.6 3.5L21.1 1 19 3.1 21.5 5.6 19 8.1 21.1 10.2 23.6 7.7 26.1 10.2 28.2 8.1 25.7 5.6 28.2 3.1 26.1 1 23.6 3.5ZM1 0L4 0 4 3 1 3 1 0ZM5 0L8 0 8 3 5 3 5 0ZM0 4L3 4 3 7 0 7 0 4ZM4 4L7 4 7 7 4 7 4 4ZM8 4L11 4 11 7 8 7 8 4ZM0 8L3 8 3 11 0 11 0 8ZM4 8L7 8 7 11 4 11 4 8ZM8 8L11 8 11 11 8 11 8 8Z"
        fill="#D8213D"
      />
    </svg>
  );
};

const { string, number, bool } = PropTypes;
OutOfStockIcon.propTypes = {
  title: string,
  height: number,
  width: number,
  toneDown: bool,
};

OutOfStockIcon.defaultProps = {
  height: 12,
  width: 30,
  title: undefined,
  toneDown: false,
};

export default OutOfStockIcon;
